import { styled, YStack } from 'tamagui';

// A YStack preset for the bordered-box look, not a wrapper: every YStack prop
// still passes through and can override these defaults at the call site.
const PSBox = styled(YStack, {
  name: 'PSBox',
  borderColor: '$color.borderColor',
  borderWidth: '$borderWidth.hairline',
  p: '$space.md',
  rounded: '$radius.base',
});

export default PSBox;
